import { render, staticRenderFns } from "./notify-scene-select.vue?vue&type=template&id=0b237587"
import script from "./notify-scene-select.vue?vue&type=script&lang=js"
export * from "./notify-scene-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports